import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FaqSection } from '../components/FaqSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-off-white font-sans text-near-black" data-id="element-192">
      <HeroSection data-id="element-193" />
      <OpeningHook data-id="element-194" />
      <ProblemSection data-id="element-195" />
      <FailedApproaches data-id="element-196" />
      <MechanismSection data-id="element-197" />
      <WhatYouGet data-id="element-198" />
      <WhoIsFor data-id="element-199" />
      <HowItWorks data-id="element-200" />
      <ProofSection data-id="element-201" />
      <FaqSection data-id="element-202" />
      <OfferSection data-id="element-203" />
      <Footer data-id="element-204" />
    </main>;
}